import { TiModalColorScheme } from '@components/TIModal';
import { LeadType } from '@utils/types';

export enum BlueconicDialogues {
  AppDownload = 'appDownload',
  Paywall = 'paywall',
  CustomUrlModal = 'customUrlModal',
  NewsletterModal = 'newsletterModal',
  LeadCaptureModal = 'leadCaptureModal',
  LeadCaptureModalWithVerticalArticles = 'leadCaptureModalWithVerticalArticles',
  LeadCaptureModalWithNewsletters = 'leadCaptureModalWithNewsletters',
  LeadCaptureModalWithNewsletter = 'leadCaptureModalWithNewsletter',
  LeadCaptureModalWithHorizontalArticles = 'leadCaptureModalWithHorizontalArticles',
  LeadCaptureModalWithSingleArticle = 'leadCaptureModalWithSingleArticle',
  LeadCaptureModalWithMultipleSubscribeOptions = 'leadCaptureModalWithMultipleSubscribeOptions',
  LeadCaptureModalWithSplitImg = 'leadCaptureModalSplitImg',
  PersonalizedReadingHub = 'personalizedReadingHub',
  RetentionP0ContentSmall = 'retentionP0',
  RetentionP1SingleContentHighlightText = 'retentionP1',
  RetentionP2SingleContentHighlightImage = 'retentionP2',
  RetentionP3MultipleContentText = 'retentionP3',
  RetentionP4MultipleContentImage = 'retentionP4',
  StickyBannerBottom = 'stickyBannerBottom',
}

export interface BlueconicProps {
  customUrl?: string;
  dialogueType: BlueconicDialogues;
  name?: string;
}

export interface BlueconicNewsletterModalProps extends BlueconicProps {
  newsletterName: string;
  newsletterDescription: string;
  frequency: string;
  newsletterId: number;
  authors: string;
  redirectUri?: string;
  buttonText?: string;
  leadType: string;
  highlight?: string;
}

export interface BlueconicPaywallProps extends BlueconicProps {
  title: string;
  subtitle?: string;
  offerLink: string;
  buttonText?: string;
  leadType?: LeadType;
}

export interface BlueconicStickyBannerBottomProps extends BlueconicProps {
  variantId: string;
  title: string;
  buttonText: string;
  redirectUri: string;
  loggedInButtonText: string;
  leadType: string;
}

export interface BlueconicCustomUrlModalProps extends BlueconicProps {
  title: string;
  subtitle: string;
  disclosure: string;
  buttonText: string;
  highlight?: string;
}

export interface BlueconicAppDownloadModalProps extends BlueconicProps {
  dialogueType: BlueconicDialogues;
}

export interface BlueconicLeadCaptureModalProps extends BlueconicProps {
  buttonText: string;
  disclosure?: string;
  highlight?: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalHorizontalArticlesProps extends BlueconicProps {
  articleSlugs: string[];
  buttonText: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalVerticalArticlesProps extends BlueconicProps {
  articleSlugs: string[];
  articleTitleSection?: string;
  buttonText: string;
  highlight?: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalSingleArticleProps extends BlueconicProps {
  highlight?: string;
  articleSlug: string;
  buttonText: string;
  leadType: string;
  offerCode?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicLeadCaptureModalSplitImgProps extends BlueconicProps {
  buttonText: string;
  highlight?: string;
  imgPathLarge: string;
  imgPathMedium: string;
  imgPathSmall: string;
  leadButtonText?: string;
  leadHighlight?: string;
  leadType: string;
  offerCode?: string;
  subtitle?: string;
  title?: string;
}

export interface BlueconicLeadCaptureModalWithNewslettersProps extends BlueconicProps {
  newsletterIds: number[];
  title: string;
  subtitle: string;
  buttonText: string;
  leadButtonText: string;
  leadType: string;
  offerCode: string;
}

export interface BlueconicLeadCaptureModalWithNewsletterProps extends BlueconicProps {
  newsletterId: number;
  subtitle: string;
  buttonText: string;
  leadType: string;
  offerCode: string;
  newsletterImageUrl?: string;
}

export interface BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps extends BlueconicProps {
  buttonText: string;
  highlight?: string;
  leadType: string;
  title: string;
  subtitle: string;
  proOfferCode: string;
  annualOfferCode: string;
}

export interface BlueconicPersonalizedReadingHubProps extends BlueconicProps {
  articlesRead: string;
  favoriteAuthors: string[];
  minutesRead: string;
  mostReadNewsletters: string[];
  mostReadTopic: string;
  mostReadTopics: string[];
  recommendedArticles: string[];
  recommendedAuthors: string[];
  recommendedNewsletters: string[];
  trendingTopics: string[];
  userId: string;
}

export interface BlueconicRetentionP0Props extends BlueconicProps {
  buttonText: string;
  modalContainerClass?: string;
  modalTheme?: TiModalColorScheme;
  subtitle: string;
  title: string;
}

export interface BlueconicRetentionP1Props extends BlueconicProps {
  highlight?: string;
  imageURL: string;
  mainCTA: string;
  mainURL: string;
  optionalCTA?: string;
  optionalURL?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicRetentionP2Props extends BlueconicProps {
  highlight?: string;
  imgPathLarge?: string;
  imgPathMedium?: string;
  imgPathSmall?: string;
  mainCTA: string;
  mainURL: string;
  optionalCTA?: string;
  optionalURL?: string;
  subtitle: string;
  title: string;
}

export interface BlueconicRetentionP3Props extends BlueconicProps {
  articleSlugs: string[];
  articleTitleSection?: string;
  buttonText: string;
  customUrl: string;
  highlight?: string;
  modalTheme?: TiModalColorScheme;
  subtitle: string;
  title: string;
}

export interface BlueconicRetentionP4Props extends BlueconicProps {
  articleSlugs: string[];
  buttonText: string;
  customUrl: string;
  subtitle: string;
  title: string;
}
